import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.map.js";
import cloneDeep from 'lodash/cloneDeep';
import { i18n } from '@/boot/i18n';
export function calculateEmojiRating(value, context, response) {
  // expect context to contain: option
  var option = context.option || context.item;

  if (!option) {
    return;
  } // try to get current rating info using option


  var rating = getExistingRatingByOption(option, response);
  var payload = rating || {
    ref: option.ref,
    comment: '',
    tags: []
  };
  payload.aspectRatingId = value;
  return payload;
} // WHY?????

export function calculateModalEmojiRating(value, context, response) {
  // Logger.debug('modalEmoji input detected')
  return calculateEmojiRating(value, context, response);
}
export function calculateRating(value, context, response) {
  // if no context, ditch out
  if (!context) {
    return;
  } // for each source type, decide what to emit
  // handle source type = modalEmoji


  if (context.source === 'modalEmoji') {
    return calculateModalEmojiRating(value, context, response);
  } // handle source type = searchResultEmoji


  if (context.source === 'searchResultEmoji') {
    return calculateSearchResultEmojiRating(value, context, response);
  } // handle source type = subcategoryEmoji


  if (context.source === 'subcategoryEmoji') {
    return calculateSubCategoryEmojiRating(value, context, response);
  } // handle source type = subQuestion


  if (context.source === 'subQuestion') {
    return calculateSubQuestionRating(value, context, response);
  } // handle source type = topLevelEmoji


  if (context.source === 'topLevelEmoji') {
    return calculateTopLevelEmojiRating(value, context, response);
  }
} //! What are the point of these?

export function calculateSearchResultEmojiRating(value, context, response) {
  // Logger.debug('searchResultEmoji input detected')
  return calculateEmojiRating(value, context, response);
}
export function calculateSubCategoryEmojiRating(value, context, response) {
  // Logger.debug('subcategoryEmoji input detected')
  return calculateEmojiRating(value, context, response);
}
export function calculateSubQuestionRating(value, _ref, response) {
  var option = _ref.option,
      subQuestion = _ref.subQuestion;

  // expect context to contain: option, subQuestion, if not, return undefined
  if (!option || !subQuestion) {
    return;
  } // try to get current rating info using option - if rating missing, create one


  var rating = getExistingRatingByOption(option, response) || {
    aspectRatingId: null,
    // TODO: a null aspectRatingId might cause problems if it gets submitted like this: check it
    comment: '',
    ref: option.ref,
    tags: []
  }; // detect subquestion type and handle accordingly

  if (subQuestion.type === 'fib-comments') {
    // handle comment type
    var payload = rating;
    payload.comment = value;
    return payload;
  }

  if (subQuestion.type === 'fib-select-option') {
    // handle reason type
    var _payload = rating;
    _payload.tags = value;
    return _payload;
  } // if subquestion type not recognised, return undefined


  return;
} //! This just dodsn't make any sense

export function calculateTopLevelEmojiRating(value, context, response) {
  // Logger.debug('modalEmoji input detected')
  return calculateEmojiRating(value, context, response);
}

function getEmojiByRatingId(id) {
  var emojis = [{
    val: 1,
    label: '',
    title: i18n.t('common.emoji.bad'),
    src: 'statics/icons/emojis/sad.svg'
  }, {
    val: 2,
    label: '',
    title: i18n.t('common.emoji.neutral'),
    src: 'statics/icons/emojis/neutral.svg'
  }, {
    val: 3,
    label: '',
    title: i18n.t('common.emoji.good'),
    src: 'statics/icons/emojis/good.svg'
  }];
  return emojis.find(function (v) {
    return v.val === id;
  });
}

export function getEmojiOptions(question) {
  return question.ratings.map(function (r) {
    return getEmojiByRatingId(r.aspectRatingId);
  });
}
export function getExistingRatingByOption(option, response) {
  return Array.isArray(response) && option ? cloneDeep(response.find(function (r) {
    return r.ref === option.ref;
  })) : null;
}
export default {
  calculateEmojiRating: calculateEmojiRating,
  calculateModalEmojiRating: calculateModalEmojiRating,
  calculateRating: calculateRating,
  calculateSubCategoryEmojiRating: calculateSubCategoryEmojiRating,
  calculateSearchResultEmojiRating: calculateSearchResultEmojiRating,
  calculateSubQuestionRating: calculateSubQuestionRating,
  getExistingRatingByOption: getExistingRatingByOption
};